import React, { useContext, useState } from 'react';
import { useToast } from '../../../../../providers/ToastProvider';
import { CompanyContext } from '../../../../../context/CompanyContext';
import { KitTemplateInput } from '../../../../../types/kit_template/kitTemplate.input';
import KitTemplateInfoPane from './Panes/KitTemplateInfo';
import { useMutation } from '@apollo/client';
import {
  KitTemplateMutations,
  UpdateKitTemplateResponse,
  UpdateKitTemplateVariables,
} from '../../../../../graphql/kitTemplate.graphql';
import { KitTemplate } from '../../../../../types/kit_template/kitTemplate';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { ToastType } from '../../../../components/Toast';
import { KitTemplateContext } from '../../../../../context/KitTemplateContext';

interface UpdateKitTemplateModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  id: string;
}

export default function UpdateKitTemplateModal({ open, setOpen, id }: UpdateKitTemplateModalProps) {
  const { currentCompany } = useContext(CompanyContext);
  const { kitTemplates, setKitTemplates } = useContext(KitTemplateContext);
  const { showToast } = useToast();

  const template = kitTemplates.get(id);
  if (!template) return null;

  const [input, setInput] = useState<KitTemplateInput>(new KitTemplateInput(template));

  const [update, { loading }] = useMutation<UpdateKitTemplateResponse, UpdateKitTemplateVariables>(
    KitTemplateMutations.update,
    {
      onCompleted: res => {
        const template = res.updateKitTemplate[0];

        kitTemplates.set(template.id, new KitTemplate(template));
        setKitTemplates(new Map(kitTemplates));

        showToast({
          type: ToastType.success,
          title: t(TranslationKey.kitTemplateUpdatedSuccessfully).singular.upper,
        });

        setOpen(false);
      },
      onError: res =>
        showToast({
          type: ToastType.error,
          title: res.message,
        }),
    },
  );

  const handleUpdate = async () => {
    await update({ variables: { templates: [input.forUpdate()] } });
  };

  return (
    <KitTemplateInfoPane
      input={input}
      setInput={setInput}
      open={open}
      setOpen={setOpen}
      loading={loading}
      onCreate={async () => {}}
      onUpdate={handleUpdate}
    />
  );
}
